import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// favicon aus JS setzen (ohne index.html anzufassen)
(function setFavicon() {
    const href = (process.env.PUBLIC_URL || '') + '/favicon.svg?v=1';
    let link = document.querySelector("link[rel='icon'][type='image/svg+xml']")
        || document.querySelector("link[rel='icon']");

    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/svg+xml';
        document.head.appendChild(link);
    } else {
        link.type = 'image/svg+xml';
    }
    link.href = href;

    // optional: ICO-Fallback anh�ngen
    if (!document.querySelector("link[rel='alternate icon']")) {
        const alt = document.createElement('link');
        alt.rel = 'alternate icon';
        alt.href = (process.env.PUBLIC_URL || '') + '/favicon.ico?v=1';
        document.head.appendChild(alt);
    }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
